export default "__VITE_PUBLIC_ASSET__aeeb7c26__"